import { computed, Directive, input } from '@angular/core';

@Directive({
  selector: '[datatableResizableCell]',
  host: {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    '[style.width]': 'width()'
  }
})
export class DatatableResizableCellDirective {
  readonly cellId = input.required<string>({
    alias: 'datatableResizableCell'
  });

  readonly width = computed(
    () => `calc(var(--col-${this.cellId()}-size) * 1px)`
  );
}
